<template>
  <div v-if="options.demographics" class="container-fluid">
    <Breadcrumb
      :values="{ Home: '/', Search: '/search', Profile: '' }"
    ></Breadcrumb>
    <div class="animated fadeIn">
      <div class="row">
        <div
          class="col-12 contents d-flex align-items-center justify-content-end"
        >
          <router-link
            :to="{ name: 'study-details', params: { id: id } }"
            class="main-category mr-3"
          >
            <font-awesome-icon icon="home"></font-awesome-icon>
            Fragrance Details
          </router-link>
          <img
            src="../assets/images/icons/excel-export-H.svg"
            class="dwn-button"
            @click="download()"
          />
        </div>
      </div>
      <div class="card mt-2">
        <div
          class="card-body d-flex flex-column justify-content-center align-items-center"
          style="min-height: 140px"
          v-if="!noData"
        >
          <template v-if="data.result && data.result.length">
            <div
              class="fragrance-header d-flex justify-content-between w-100 mb-3"
            >
              <div>
                <div>
                  <div class="header-label">Project name:</div>
                  <span>{{ parseStudyInfo(data.info.project_name) }}</span>
                </div>
                <div>
                  <div class="header-label">Client:</div>
                  <span>{{ parseStudyInfo(data.info.client) }}</span>
                </div>
                <div>
                  <div class="header-label">
                    Fragrance name / 6 digit code (SAP):
                  </div>
                  <span
                    >{{ parseStudyInfo(data.info.name) }} /
                    {{ parseStudyInfo(data.info.code) }}</span
                  >
                </div>
              </div>
              <div>
                <div class="d-flex flex-column">
                  <span class="text-right header-label"
                    >Proj. nr / Frag code / Dev. nr:</span
                  >
                  <span class="text-right"
                    >{{ parseStudyInfo(data.info.c_mi_number) }} /
                    {{ parseStudyInfo(data.info.prod) }} /
                    {{ parseStudyInfo(data.info.ref_number) }}</span
                  >
                </div>
                <div class="d-flex flex-column">
                  <div class="text-right header-label">
                    Category / Product :
                  </div>
                  <span class="text-right"
                    >{{ parseStudyInfo(data.info.category) }} /
                    {{ parseStudyInfo(data.info.product) }}</span
                  >
                </div>
              </div>
            </div>
            <div
              class="d-flex justify-content-between align-items-center w-100"
            >
              <div class="d-flex align-items-center">
                <div>
                  <el-select
                    v-model="fragranceFilters.category"
                    placeholder="Select filter"
                    filterable
                    @change="fragranceFilters.value = ''"
                    collapse-tags
                  >
                    <el-option-group label="Press Tab/Escape to exit">
                      <el-option
                        v-for="value in filterList"
                        :key="value"
                        :label="parseLabel(value)"
                        :value="value"
                      >
                      </el-option>
                    </el-option-group>
                  </el-select>
                </div>
                <div v-if="fragranceFilters.category" class="ml-2">
                  <el-select
                    v-model="fragranceFilters.value"
                    placeholder="Select value"
                    filterable
                    collapse-tags
                  >
                    <el-option-group label="Press Tab/Escape to exit">
                      <el-option
                        v-for="value in this.options.demographics[
                          fragranceFilters.category
                        ]"
                        :key="typeof value === 'object' ? value.label : value"
                        :label="typeof value === 'object' ? value.label : value"
                        :value="typeof value === 'object' ? value.label : value"
                      >
                      </el-option>
                    </el-option-group>
                  </el-select>
                </div>
                <div class="search-error">{{ error }}</div>
              </div>
              <div class="d-flex justify-content-center align-items-center">
                <button
                  class="search-button btn btn-block btn-outline-danger"
                  @click="clearFilters()"
                >
                  Clear
                </button>
                <button
                  class="search-button btn btn-block btn-outline-primary ml-2 mt-0"
                  @click="getData()"
                >
                  Filter
                </button>
              </div>
            </div>
            <div class="footnote mb-4">
              <span class="footnote-text"
                >All scores and metrics have been harmonized to a common 5 point
                scale</span
              >
              <span v-if="showBinaryScaleInfo" class="footnote-text"
                >*This is a CATA (dichotomous variable) harmonized to a 5 points
                scale, therefore there are no neutral scores".</span
              >
            </div>
            <el-input
              v-model="tableQuery"
              placeholder="Filter tables"
              clearable
              @input="changeTableQuery"
              class="filter-input"
            >
            </el-input>
            <template
              v-if="
                nonStrengthPerformanceTable.data &&
                  nonStrengthPerformanceTable.data.length &&
                  !isGenisys
              "
            >
              <h5>Performance data:</h5>
              <Table
                class="frag-profile-table"
                style="margin-bottom: 50px;"
                :show-download="false"
                ref="firstTable"
                :hide-filters="true"
                :data="nonStrengthPerformanceTable.data"
                :columns="nonStrengthPerformanceTable.columns"
                :options="nonStrengthPerformanceTable.options"
              ></Table>
              <Table
                class="frag-profile-table"
                style="margin-bottom: 50px;"
                :show-download="false"
                ref="secondTable"
                :hide-filters="true"
                :data="strengthPerformanceTable.data"
                :columns="strengthPerformanceTable.columns"
                :options="strengthPerformanceTable.options"
              ></Table>
            </template>
            <template
              v-if="
                attributesTable.data &&
                  attributesTable.data.length &&
                  !isGenisys
              "
            >
              <h5>Attributes data:</h5>
              <Table
                class="frag-profile-table"
                :show-download="false"
                :data="attributesTable.data"
                ref="thirdTable"
                :hide-filters="true"
                :columns="attributesTable.columns"
                :options="attributesTable.options"
              ></Table>
            </template>
            <template v-if="genisys.data && genisys.data.length && isGenisys" >
              <h3 class="mt-3">Genisys data:</h3>
              <Table
                class="frag-profile-table"
                :show-download="false"
                :data="genisys.data"
                ref="genisysTable"
                :hide-filters="true"
                :columns="genisys.columns"
                :hide-filters-list="true"
              ></Table>
              <div class="input-wrapper mr-2" v-if="isTimeSeriesAvailable">
                <label>Metric</label>
                <el-select v-model="metricSelected" collapse-tags multiple @change="filterTable">
                  <el-option-group label="Press Tab/Escape to exit">
                    <!-- eslint-disable-next-line vue/no-v-for-template-key -->
                    <template v-for="type in filteredTimeSeriesKeys" :key="type">
                      <el-option
                        :ref="type"
                        :value="type"
                        :label="type"
                      >
                      </el-option>
                    </template>
                  </el-option-group>
                </el-select>
              </div>
              <div class="col-10 d-flex" v-if="isTimeSeriesAvailable">
                <div class="chart-wrapper d-flex">
                  <LineChart
                    ref="genisysChart"
                    :chart-data="genisysChart.data"
                    :options="genisysChart.options"
                    style="height: 300px; margin-bottom: 10px"
                  ></LineChart>
                </div>
              </div>
              <span v-else class="no-attributes-warning text-center">No time series data available.</span>
            </template>
            <span
              v-if="
                !nonStrengthPerformanceTable.data &&
                  !nonStrengthPerformanceTable.data.length &&
                  !attributesTable.data &&
                  !attributesTable.data.length &&
                  !genisys.data &&
                  !genisys.data.length
              "
              class="no-attributes-warning"
              >Attributes were not detected for this specific fragrance.</span
            >
          </template>
        </div>
        <div
          class="card-body d-flex flex-column justify-content-center align-items-center"
          style="height: 140px"
          v-else
        >
          <div
            class="d-flex justify-content-between align-items-center w-100 mb-4"
          >
            <div class="d-flex align-items-center">
              <div>
                <el-select
                  v-model="fragranceFilters.category"
                  placeholder="Select filter"
                  filterable
                  collapse-tags
                  @change="fragranceFilters.value = ''"
                >
                  <el-option-group label="Press Tab/Escape to exit">
                    <el-option
                      v-for="value in Object.keys(this.options.demographics)"
                      :key="value"
                      :label="parseLabel(value)"
                      :value="value"
                    >
                    </el-option>
                  </el-option-group>
                </el-select>
              </div>
              <div v-if="fragranceFilters.category" class="ml-2">
                <el-select
                  v-model="fragranceFilters.value"
                  placeholder="Select value"
                  filterable
                  collapse-tags
                >
                  <el-option-group label="Press Tab/Escape to exit">
                    <el-option
                      v-for="value in this.options.demographics[
                        fragranceFilters.category
                      ]"
                      :key="value"
                      :label="value"
                      :value="value"
                    >
                    </el-option>
                  </el-option-group>
                </el-select>
              </div>
            </div>
            <div class="d-flex justify-content-center align-items-center">
              <button
                class="search-button btn btn-block btn-outline-danger"
                @click="clearFilters()"
              >
                Clear
              </button>
              <button
                class="search-button btn btn-block btn-outline-primary ml-2 mt-0"
                @click="getData()"
              >
                Filter
              </button>
            </div>
          </div>
          <div class="footnote mb-4">
            <span class="footnote-text"
              >All scores and metrics have been harmonized to a common 5 point
              scale</span
            >
          </div>
          <div style="min-height: 100px">
            <i>No fragrance profile data</i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

import studiesActions from '../store/modules/studies/actionTypes'
import { mapActions } from 'vuex'
import generalActions from '../store/modules/general/actionTypes'
import Breadcrumb from '../components/shared/Breadcrumb'
import Table from '../components/shared/Table'
import fileNames from '../constants/fileNames'
import LineChart from '../components/shared/LineChart'
import utilsFunctions from '../helpers/utilsFunctions'

export default {
  name: 'FragranceProfile',
  props: {},
  components: { Table, Breadcrumb, LineChart },
  data () {
    return {
      fragranceFilters: {
        category: '',
        value: ''
      },
      showBinaryScaleInfo: false,
      nonStrengthPerformanceTable: {
        columns: [
          'metric_type',
          'metric_name',
          'mean',
          'top_box',
          'top_2_box',
          'just_right',
          'bottom_box',
          'bottom_2_box'
        ],
        data: [],
        options: {
          headings: {
            just_right: 'Neutral'
          }
        }
      },
      strengthPerformanceTable: {
        columns: [
          'metric_type',
          'metric_name',
          'mean',
          'top_box',
          'top_2_box',
          'just_right',
          'bottom_box',
          'bottom_2_box'
        ],
        data: [],
        options: {
          headings: {
            top_2_box: 'Strong',
            top_box: 'Too strong',
            bottom_box: 'Too weak',
            bottom_2_box: 'Weak'
          }
        }
      },
      attributesTable: {
        columns: [
          'metric_type',
          'metric_name',
          'mean',
          'top_box',
          'top_2_box',
          'just_right',
          'bottom_box',
          'bottom_2_box'
        ],
        data: [],
        options: {
          headings: {
            just_right: 'Neutral'
          },
          rowClassCallback: (row) => {
            let attrList = this.$route.query.attributes
              ? JSON.parse(this.$route.query.attributes)
              : []
            return attrList.includes(
              row.metric_name.replace(/\//g, '_').toLowerCase()
            )
              ? ' fp-row-selected'
              : ''
          }
        }
      },
      genisys: {
        columns: ['metric_type', 'metric_name', 'mean'],
        data: [],
        metricType: []
      },
      genisysTableData: [],
      genisysChart: {
        options: {
          responsive: true,
          maintainAspectRatio: false,
          elements: {
            line: {
              tension: 0
            }
          },
          legend: {
            display: false
          }
        },
        data: {}
      },
      metricSelected: [],
      id: this.$route.params.id,
      options: {},
      data: {
        result: [],
        filters: [],
        time_series: {}
      },
      filters: {},
      tableQuery: '',
      sortBy: {
        key: 'metric_type',
        desc: true
      },
      noData: false,
      error: '',
      isGenisys: false,
      attributes: this.$route.query.attributes
        ? JSON.parse(this.$route.query.attributes)
        : [],
      time_series: [],
      isTimeSeriesAvailable: false
    }
  },
  computed: {
    metricList () {
      return Array.isArray(this.data.result)
        ? this.data.result.map((el) => el.metric)
        : []
    },
    filterList () {
      return this.options.demographics
        ? Object.keys(this.options.demographics).filter(
          (el) =>
            Array.isArray(this.data.filters) &&
            this.data.filters.includes(el.toLowerCase()) &&
            el !== 'bumo'
        )
        : []
    },
    aggregationList () {
      if (Array.isArray(this.data.result) && this.data.result.length) {
        let list = Object.keys(this.data.result[0])
        list.splice(list.indexOf('metric'), 1)
        return list
      }
      return []
    },
    filteredData () {
      const arrayCopy = _.clone(Array.isArray(this.data.result) ? this.data.result : [])
      const sortedArray = arrayCopy.sort((a, b) => {
        if (a[this.sortBy.key] < b[this.sortBy.key]) {
          return -1
        }
        if (a[this.sortBy.key] > b[this.sortBy.key]) {
          return 1
        }
        return 0
      })
      return this.sortBy.desc ? sortedArray : sortedArray.reverse()
    },
    filteredTimeSeriesKeys () {
      const timeSeries = this.data && this.data.time_series && typeof this.data.time_series === 'object'
        ? this.data.time_series
        : {}
      let x = Object.keys(timeSeries).filter((el) => {
        return ['hfd_hedonic',
          'addiction',
          'cogproc',
          'attention',
          'relaxation',
          'energizing'].includes(el)
      })
      return this.genisys.data.map((el) => {
        return x.includes(el.metric)
          ? el.metric_name
          : undefined
      }).filter((el) => el !== undefined)
    }
  },
  methods: {
    ...mapActions({
      getAnalyticsFields: studiesActions.FETCH_ANALYTICS_FIELDS,
      getProfileData: studiesActions.FETCH_FRAGRANCE_PROFILE,
      getXLSX: studiesActions.GET_FRAGRANCE_PROFILE_XLSX,
      toggleLoading: generalActions.TOGGLE_LOADING
    }),
    parseLabel (value) {
      const string = value.replace(/_+/g, ' ')
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    parseStudyInfo (value) {
      if (value) {
        return value === 'nan' ? '-' : value
      }
      return '-'
    },
    parseData (data, aggregationValue) {
      const value = data[aggregationValue]
      if (aggregationValue === 'is_binary_scale') {
        return value
      }
      return Object.keys(data) && value
        ? ['metric_type', 'metric_name'].includes(aggregationValue)
          ? this.parseLabel(value) || '-'
          : aggregationValue === 'mean'
            ? typeof value === 'string'
              ? value
              : value.toFixed(2)
            : typeof value === 'string'
              ? value
              : Math.round(value) + '%'
        : '-'
    },
    parseTableData (data) {
      let values = _.cloneDeep(Array.isArray(data) ? data : [])
      values.forEach((row, index) => {
        Object.keys(row).forEach((key) => {
          values[index][key] = this.parseData(row, key)
        })
      })
      return values
    },
    changeSort (newKey) {
      if (this.sortBy.key === newKey) {
        const test = !this.sortBy.desc
        this.$set(this.sortBy, 'desc', test)
      } else {
        this.$set(this.sortBy, 'key', newKey)
        this.$set(this.sortBy, 'desc', true)
      }
    },
    getFilterData () {
      const parsedQuery = {
        demographics: []
      }
      const { category, value } = this.fragranceFilters
      if (category && value) {
        parsedQuery.demographics.push(
          category === 'social_class'
            ? this.options.demographics.social_class.find(
              (el) => el.label === value
            ).value
            : {
              field: category,
              filter: {
                type: 'equal',
                value: value
              }
            }
        )
      }
      return parsedQuery
    },
    clearFilters () {
      this.fragranceFilters = {
        category: '',
        value: ''
      }
    },
    setTableQueries () {
      if (!this.isGenisys) {
        this.$refs.firstTable.setQuery(this.tableQuery)
        this.$refs.secondTable.setQuery(this.tableQuery)
        this.$refs.thirdTable.setQuery(this.tableQuery)
      } else {
        this.$refs.genisysTable.setQuery(this.tableQuery)
      }
    },
    changeTableQuery () {
      this.setTableQueries()
    },
    checkAndAddMissingAttributes (data) {
      if (!data || !Array.isArray(data.result)) return

      const necessaryMetrics = ['liking', 'strength', 'purchase_intention']
      const values = data.result.filter((el) =>
        necessaryMetrics.includes(el.metric)
      )
      if (values.length < 3) {
        necessaryMetrics.forEach((metric) => {
          if (!values.filter((el) => el.metric === metric).length) {
            this.data.result.push({
              metric,
              metric_name: this.parseLabel(metric),
              metric_type: 'Performance',
              top_box: 'N/A',
              top_2_box: 'N/A',
              just_right: 'N/A',
              bottom_box: 'N/A',
              bottom_2_box: 'N/A',
              mean: 'N/A'
            })
          }
        })
      }
    },
    async download () {
      const response = await this.getXLSX({
        q: this.getFilterData(),
        id: this.$route.params.id,
        code: this.$route.params.code
      })
      const url = window.URL.createObjectURL(new Blob([response]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileNames.fragranceProfile)
      document.body.appendChild(link)
      link.click()
    },
    async getData () {
      this.toggleLoading(true)
      try {
        const response = await this.getProfileData({
          id: this.$route.params.id,
          code: this.$route.params.code,
          data: this.getFilterData()
        })
        if (response) {
          this.data = {
            result: [],
            filters: [],
            time_series: {},
            ...response
          }
          this.noData = !this.data
          if (!this.noData) {
            this.checkAndAddMissingAttributes(this.data)
          }
          const parsedTableData = this.parseTableData(this.data.result)
          this.nonStrengthPerformanceTable.data = parsedTableData.filter(
            (el) =>
              el.metric_type === 'Performance' && el.metric_name !== 'Strength'
          )
          this.strengthPerformanceTable.data = parsedTableData.filter(
            (el) =>
              el.metric_type === 'Performance' && el.metric_name === 'Strength'
          )
          this.genisys.data = parsedTableData.filter(
            (el) => el.metric_type === 'Performance' &&
              !['liking', 'strength', 'purchase intention'].includes(
                el.metric_name.toLowerCase()
              )
          )
          this.attributesTable.data = parsedTableData.filter(
            (el) => el.metric_type !== 'Performance'
          )
          let attrList = this.$route.query.attributes
            ? JSON.parse(this.$route.query.attributes)
            : []
          if (attrList && attrList.length) {
            attrList = attrList.filter(
              (el) =>
                !['strength', 'liking', 'purchase_intent'].includes(
                  el.toLowerCase()
                )
            )
            const metricNames = this.attributesTable.data
              .filter((el) => {
                return attrList.includes(
                  el.metric_name.replace(/\//g, '_').toLowerCase()
                )
              })
              .map((el) => el.metric_type)
            this.attributesTable.data
              .sort((a, b) => {
                return metricNames.includes(a.metric_type)
                  ? -1
                  : metricNames.includes(b.metric_type)
                    ? 1
                    : 0
              })
              .sort((a, b) => {
                return attrList.includes(
                  a.metric_name.replace(/\//g, '_').toLowerCase()
                )
                  ? -1
                  : attrList.includes(
                    b.metric_name.replace(/\//g, '_').toLowerCase()
                  )
                    ? 1
                    : 0
              })
          }
          this.showBinaryScaleInfo = this.attributesTable.data.some(
            (el) => el.is_binary_scale
          )
          this.error = ''
        } else {
          this.clearFilters()
          this.error =
            'No data found for provided filters, displaying previous data.'
        }
      } catch {
        this.clearFilters()
        this.error = 'Failed to load fragrance profile data. Please try again.'
      } finally {
        this.toggleLoading(false)
      }
    },
    filterTable () {
      const selectedMetrics = Array.isArray(this.metricSelected)
        ? this.metricSelected
        : []
      const datasets = this.genisysChart &&
        this.genisysChart.data &&
        Array.isArray(this.genisysChart.data.datasets)
        ? this.genisysChart.data.datasets
        : []

      if (selectedMetrics.length > 0) {
        this.genisysTableData = this.genisys.data.filter(el => {
          if (selectedMetrics.includes(el.metric_name)) {
            return el
          }
        })
        datasets.forEach((dataset) => {
          dataset.hidden = !selectedMetrics.includes(dataset.label)
        })
      } else {
        this.genisysTableData = this.genisys.data
        datasets.forEach((dataset) => {
          dataset.hidden = false
        })
      }
      if (this.$refs.genisysChart && datasets.length) {
        this.$refs.genisysChart.reRender()
      }
    }
  },
  async mounted () {
    this.options = await this.getAnalyticsFields()
    await this.getData()
    this.isGenisys = this.genisys.data.length > 0
    this.genisys.metricType = this.genisys.data.map(el => el.metric_name)
    this.metricSelected = this.attributes.length
      ? this.genisys.data.map(el => {
        if (this.attributes.includes(el.metric)) {
          return el.metric_name
        }
      }).filter(el => el !== undefined)
      : []
    this.genisysTableData = this.genisys.data
    let datasets = []
    if (this.isGenisys) {
      const timeSeries = this.data && this.data.time_series && typeof this.data.time_series === 'object'
        ? this.data.time_series
        : {}
      const filteredTimeSeries = Object.keys(timeSeries).filter((el) => {
        return ['hfd_hedonic',
          'addiction',
          'cogproc',
          'attention',
          'relaxation',
          'energizing'].includes(el)
      })
      this.isTimeSeriesAvailable = filteredTimeSeries.length > 0
      if (this.isTimeSeriesAvailable) {
        filteredTimeSeries.forEach(metric => {
          const metricData = timeSeries[metric] || {}
          const metricDataArray = Object.keys(metricData).map(label => {
            return {
              x: Number(label),
              y: metricData[label]
            }
          })
          metricDataArray.sort((a, b) => a.x - b.x)
          const label = String(this.genisys.data.map(el => {
            if (el.metric === metric) {
              return el.metric_name
            }
          }).filter(el => el !== undefined))
          const colour = utilsFunctions.stringToColour(label)
          datasets.push({
            label: label,
            data: metricDataArray,
            borderColor: colour,
            pointBorderColor: colour,
            fill: false,
            hidden: !this.metricSelected.includes(label)
          })
        })
        const firstTimeSeriesMetric = filteredTimeSeries[0]
        this.genisysChart.data = {
          labels: Object.keys(timeSeries[firstTimeSeriesMetric] || {})
            .map(Number).sort((a, b) => a - b),
          datasets: datasets
        }
      }
    }
    if (this.isTimeSeriesAvailable) {
      this.filterTable()
    }
  }
}
</script>

<style scoped lang="scss">
@import "../assets/scss/variables";

.input-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 40%;
}

.chart-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}

.card {
  background-color: rgba(255, 255, 255, 0.63);
}

.table-field {
  flex: 1;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.secondary {
  background-color: rgb(245, 247, 255);
}

.table-label {
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex: 1;
  transition: background-color 0.1s linear;
  border-bottom: 1px solid #d1d4d7;
}

.table-label:hover {
  background-color: #eeeeee;
}

.row-label {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  border-top: 1px solid #d1d4d7;
  border-bottom: 1px solid #d1d4d7;
}

.table {
  border-top: 1px solid #d1d4d7;
}

.frag-profile-table {
  width: 80%;
}

.main-category {
  color: $magento;
  font-size: 17px;
}

.search-button {
  border-radius: 4px;
}

.footnote {
  margin-top: 10px;
  align-self: flex-start;
  display: flex;
  flex-direction: column;
  height: unset;
}

.footnote-text {
  color: #959799;
  font-size: 16px;
}

.no-attributes-warning {
  font-size: 20px;
  color: $red-400;
  text-transform: uppercase;
}

.fragrance-header {
  font-size: 20px;
}

.header-label {
  font-size: 14px;
  color: #959799;
}

.search-error {
  font-size: 14px;
  color: #c24748;
  margin-left: 15px;
}

.excel-download-button {
  width: 240px;
  height: 48px;
  background-color: $celery-500;
  border-radius: 4px;
  font-family: "Open Sans", sans-serif;
  font-weight: 900;
  font-size: 16px;
  line-height: 30px;
  letter-spacing: 0;
  text-transform: uppercase;
  color: white;

  transition: background-color 0.2s linear;

  &:hover {
    color: white;
    background-color: $celery-700;
  }
}
</style>
